/*
 * @Author: suxiao
 * @Date: 2019-08-27 11:28:20
 * @LastEditors: zhangkaiqiang
 * @Description: 去掉是否有邀请码选择框
 */
const state = {
  contactIndex: 0,
  stepIndex: 0,
  merchantInfo: {
    contactUsername: '',
    contactPosition: '',
    contactMobile: '',
    contactWeixin: '',
    contactEmail: '',
    contactEnterpriseAuthorizationObjectId: '',
    contactIdCardFrontObjectId: '',
    contactIdCardBackObjectId: '',
    contactIsInvited: 'Y', // 默认为true，避免后端参数逻辑问题
    contactInviteCode: '',
    companyRegistrationName: '',
    companyUnifiedSocialCreditCode: '',
    companyProvince: '',
    companyCity: '',
    companyDistrict: '',
    companyAddress: '',
    companyEstablishDate: '',
    companyRegisteredCapital: '',
    companyOperatingPeriodStart: '',
    companyOperatingPeriodEnd: '',
    companyOperatingPeriodIsLongTermEffective: '',
    companyBusinessScope: '',
    companyEmployeeSize: '',
    companyTaxpayerType: '',
    companyTaxpayerTypeCode: '',
    companyBusinessLicenseObjectId: '',
    companyOpeningBankAccountPermissionObjectId: null,
    legalIdCardType: '',
    legalIdCardCode: '',
    legalIdCardName: '',
    legalIdCardExpireDateStart: '',
    legalIdCardExpireDateEnd: '',
    legalIdCardIsLongTermEffective: '',
    legalIdCardFrontObjectId: '',
    legalIdCardBackObjectId: ''
  },
  applyStatus: false,
  loginStatus: false,
  addressInfo: {},
  brandInfo: {
    brandId: '',
    brandName: '',
    brandEnglishName: '',
    brandLogo: '',
    brandSlogan: '',
    brandIntroduction: '',
    brandType: '',
    managementType: '',
    brandMainProduct: '',
    mainProductImg: '',
    mainProductSellingPoint: '',
    brandCustomerMinAge: '',
    brandCustomerMaxAge: '',
    brandPatent: '',
    thirdPartyPlatformSalesCertificate: [],
    brandAnnualTotalConsumption: '',

    proxyLevel: '1',
    proxyInfosTotal: [
      {
        level: '1',
        objectId: '',
        startDate: '',
        endDate: ''
      },
      {
        level: '2',
        objectId: '',
        startDate: '',
        endDate: ''
      },
      {
        level: '3',
        objectId: '',
        startDate: '',
        endDate: ''
      },
      {
        level: '4',
        objectId: '',
        startDate: '',
        endDate: ''
      },
      {
        level: '5',
        objectId: '',
        startDate: '',
        endDate: ''
      }
    ],
    proxyInfos: [
      {
        level: '1',
        objectId: '',
        startDate: '',
        endDate: ''
      }
    ],
    categoryId: []
  },
  categoryCache: new Map(),
  isAdmin: false, // 是否主账号
  isStaioned: false, // 是否入驻成功
  isOverseas: false, // 是否海淘商家
  enterState: 'FRESHMAN',
  signState: 'NOT_START',
  signData: {},
  operationLog: {},
  reviewDuration: 0, // 审批已用时间
  applicationId: '', // 申报单ID
  merchantData: {
    contact: {},
    company: {},
    legal: {},
    category: {},
    brand: {}
  }
}

export default state
